import { useEffect } from "react";
import { useTranslation } from "react-i18next";

/**
 * Shared setup for the public, full-document pages (landing, legal).
 *
 * 1. Releases `#root` from `height: 100vh`.
 *
 *    index.css sets `#root { height: 100vh }` and `overflow-x: hidden`, which
 *    together make `#root` the scroll container — inside the app the document
 *    itself never scrolls. That is wrong for a long public page: `window.scrollY`
 *    would stay at 0 (breaking the landing header's scroll listener) and a long
 *    document would be trapped in a 100vh box. `html.landing-active #root`
 *    switches it to `height: auto`, and this hook owns that class.
 *
 * 2. Keeps `<html lang>` in sync with the selected language, which drives
 *    screen-reader pronunciation and hyphenation.
 */
export default function usePublicPageShell() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.classList.add("landing-active");
    return () => document.documentElement.classList.remove("landing-active");
  }, []);

  useEffect(() => {
    document.documentElement.lang = i18n.language || "kk";
  }, [i18n.language]);
}
